import {getSectionFieldsMap} from 'hooks/Product/FormFieldStructure';
import {GenericError} from 'components/customer/Product/entity';
import {Structure} from 'components/customer/Product/entity/Structure';
import {MATERIAL_RESTRICTION_MESSAGES} from 'shared/validator';

interface TabErrorInterface {
    [key: string]: number;
}

export const getTabErrors = (
    formStructure: Structure[],
    errors: GenericError[]
) => {
    const tabErrorValues: TabErrorInterface = {};
    const filteredFormStructure = formStructure.filter(
        (fs) => fs?.layout != 'sidebar'
    );
    const fields = getSectionFieldsMap(filteredFormStructure);

    const materialTabIndex =
        filteredFormStructure
            .map((fs) => fs.name.toLowerCase())
            .indexOf('materials') || 1;

    if (errors?.find((e) => e.fields && e.fields.includes('custom_colour_ext')))
        fields['custom_colour_ext'] = materialTabIndex;

    if (
        errors?.find((e) => e.fields && e.fields.includes('custom_colour_carc'))
    )
        fields['custom_colour_carc'] = materialTabIndex;

    const drawerTabIndex =
        filteredFormStructure
            .map((fs) => fs.name.toLowerCase())
            .indexOf('drawers') || 2;
    if (errors?.find((e) => e.fields && e.fields.includes('drawers')))
        fields['drawers'] = drawerTabIndex;

    Object.keys(fields).forEach((fieldName) => {
        errors.forEach((error) => {
            if (
                error.fields &&
                Array.isArray(error.fields) &&
                error.fields
                    .map((field) => field.indexOf(fieldName) > -1)
                    .some(Boolean)
            ) {
                // checking for presence of fieldName as indexed fieldname won't match
                // and we don't have index here to check
                if (tabErrorValues[String(fields[String(fieldName)])]) {
                    tabErrorValues[String(fields[String(fieldName)])] += 1;
                } else {
                    tabErrorValues[String(fields[String(fieldName)])] = 1;
                }
            }
        });
    });

    // hidden material/edge/door errors have no fields so match by message
    errors?.forEach((error) => {
        if (
            error.message &&
            MATERIAL_RESTRICTION_MESSAGES.includes(error.message)
        ) {
            if (tabErrorValues[String(materialTabIndex)]) {
                tabErrorValues[String(materialTabIndex)] += 1;
            } else {
                tabErrorValues[String(materialTabIndex)] = 1;
            }
        }
    });

    return tabErrorValues;
};
